import {
  Tooltip,
  Card,
  Typography,
  Input,
  Button,
  Switch,
  Pagination,
  Form,
  Empty,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useState, useEffect } from "react";
import SortingArrow from "../../Common/SortingArrow";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { changeLoader } from "../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import {
  checkPermissionAction,
  formatDateFunction,
} from "../../utils/helper/utils";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
let timer = null;

const ManageVendor = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [itemData, setItemData] = useState(0);

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_VENDOR?.UPDATE_STATUS + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Vendor deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllVendors();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllVendors = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.GET_ALL_VENDORS,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllVendors();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_VENDOR?.UPDATE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Vendor active successfully";
        if (item.status === "active") msg = "Vendor inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllVendors();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  return (
    <>
      <Card>
        <div className="block sm:flex justify-between	mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Manage Vendor
            </Typography>
          </div>
          <div className="block sm:flex">
            <Form form={form} layout="vertical">
              <Form.Item name="search">
                <Search
                  placeholder="Search..."
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "trim");
                    form.setFieldValue("search", value);
                    setInputData((prev) => ({ ...prev, search: value }));
                    setPaginationModel((prev) => ({ ...prev, page: 1 }));
                  }}
                  style={{
                    width: window.innerWidth < 768 ? "100%" : 300,
                  }}
                  className="mx-1.5 cursor-pointer mt-3 sm:mt-0"
                />
              </Form.Item>
            </Form>
            {checkPermissionAction("Manage Vendor", permissionJson, "add") ? (
              <Button
                type="primary"
                size={14}
                icon={<PlusOutlined />}
                className="mx-1.5 cursor-pointer"
                onClick={() => navigate("/add-vendor")}
              >
                Add new Vendor
              </Button>
            ) : null}
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  ID{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("id", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Business Name{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("businessName", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Store name{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("storeName", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Vendor name{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("firstName", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Mobile Number{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("mobileNo", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Email address{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("email", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Commercial Registration number{" "}
                  <SortingArrow
                    onSort={(order) =>
                      handleSort("commercialRegistrationNumber", order)
                    }
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Total number of branches{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("noOfBranches", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Subscription Plan
                  <SortingArrow
                    onSort={(order) => handleSort("subscriptionPlan", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Subscription Start date
                  <SortingArrow
                    onSort={(order) => handleSort("startDate", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Subscription End date
                  <SortingArrow
                    onSort={(order) => handleSort("endDate", order)}
                  />
                </th>
                 <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Created date & time{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("createdAt", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3">
                  Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 text-center whitespace-nowrap vertical-top"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.vendorDetail?.businessName || "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.vendorDetail?.storeName || "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.firstName + " " + item?.lastName}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.mobileNo}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.email}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap text-center">
                      {item?.vendorDetail?.commercialRegistrationNumber}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap text-center">
                      {item?.vendorDetail?.noOfBranches}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap text-center">
                      {item?.vendorDetail?.subscriptionId}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {formatDateFunction(item?.vendorDetail?.planStartDate, "dd/mm/yyyy", false)}
                    </td>
                     <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {formatDateFunction(item?.vendorDetail?.planEndDate, "dd/mm/yyyy", false)}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {formatDateFunction(item?.createdAt, "dd/mm/yyyy", true)}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <Switch
                        checked={item?.status === "active" ? true : false}
                        onChange={() => {
                          handleStatusChange(item);
                        }}
                        disabled={
                          !checkPermissionAction(
                            "Manage Vendor",
                            permissionJson,
                            "update_status"
                          )
                        }
                      />
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                      <Tooltip title="Edit">
                        <EditOutlined
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Manage Vendor",
                                permissionJson,
                                "edit"
                              )
                            ) {
                              navigate("/edit-vendor/" + item.id);
                            }
                          }}
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Manage Vendor",
                              permissionJson,
                              "edit"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Manage Vendor",
                              permissionJson,
                              "delete"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Manage Vendor",
                                permissionJson,
                                "delete"
                              )
                            ) {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }
                          }}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) =>
                setPaginationModel((prev) => ({ ...prev, page: page }))
              }
              onShowSizeChange={(current, size) =>
                setPaginationModel((prev) => ({ ...prev, limit: size }))
              }
            />
          </div>
        ) : null}
      </Card>
      {/* delete modal */}
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="Are you sure you want to delete this Vendor?"
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
      />
    </>
  );
};
export default ManageVendor;
